import API_BASE_URL from './config';
import React, { useState, useEffect, useCallback } from 'react';

function Wiki() {
  const [items, setItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const fetchItems = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/wiki/items` + (searchTerm ? `?search=${encodeURIComponent(searchTerm)}` : ''));
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`HTTP error! Status: ${res.status} - ${text}`);
      }
      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await res.text();
        throw new Error(`Expected JSON, but received: ${text}`);
      }
      const data = await res.json();
      const filteredItems = selectedCategory ? data.filter(item => item.category === selectedCategory) : data;
      setItems(filteredItems);
      setMessage(filteredItems.length ? '' : 'No items found.');
    } catch (error) {
      console.error('Fetch error details:', error);
      setMessage('Failed to fetch items: ' + error.message);
    } finally {
      setLoading(false);
    }
  }, [searchTerm, selectedCategory]);

  const fetchCategories = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/wiki/categories`);
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`HTTP error! Status: ${res.status} - ${text}`);
      }
      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await res.text();
        throw new Error(`Expected JSON, but received: ${text}`);
      }
      const data = await res.json();
      console.log('Fetched categories:', data); // Debug log
      setCategories(['All', ...data]);
    } catch (error) {
      console.error('Categories fetch error:', error);
      setMessage('Failed to fetch categories: ' + error.message);
    }
  }, []);

  useEffect(() => {
    fetchItems();
  }, [fetchItems, searchTerm, selectedCategory]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value === 'All' ? '' : e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchItems();
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '60px 20px', textAlign: 'center' }}>
      <h1 style={{ color: '#1E88E5', fontSize: '2em', marginBottom: '20px' }}>DFG Item Wiki</h1>
      {message && (
        <div style={{
          backgroundColor: '#FFCDD2',
          padding: '10px',
          marginBottom: '20px',
          borderRadius: '5px',
          color: '#D32F2F',
          fontWeight: 'bold',
          textAlign: 'center'
        }}>
          {message}
        </div>
      )}
      <div style={{ marginBottom: '20px' }}>
        <label htmlFor="categoryFilter" style={{ marginRight: '10px', color: '#1E88E5', fontWeight: 'bold' }}>Filter by Category: </label>
        <select
          id="categoryFilter"
          value={selectedCategory}
          onChange={handleCategoryChange}
          style={{
            padding: '8px',
            borderRadius: '5px',
            border: '1px solid #BBDEFB',
            fontSize: '1em',
            backgroundColor: '#fff'
          }}
        >
          {categories.map((cat, index) => (
            <option key={index} value={cat}>{cat}</option>
          ))}
        </select>
      </div>
      <form onSubmit={handleSubmit} style={{ marginBottom: '20px' }}>
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Search by item name..."
          style={{
            padding: '8px',
            width: '70%',
            borderRadius: '5px',
            border: '1px solid #BBDEFB',
            fontSize: '1em',
            marginRight: '10px'
          }}
        />
        <button
          type="submit"
          style={{
            padding: '8px 15px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={e => e.target.style.backgroundColor = '#45A049'}
          onMouseOut={e => e.target.style.backgroundColor = '#4CAF50'}
        >
          Search
        </button>
      </form>
      {loading ? (
        <p style={{ color: '#888' }}>Loading...</p>
      ) : (
        <div style={{ textAlign: 'left' }}>
          {items.map(item => (
            <div key={item.itemId} style={{
              backgroundColor: '#f9f9f9',
              padding: '15px',
              marginBottom: '10px',
              borderRadius: '5px',
              border: '1px solid #d9ead3',
              boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
            }}>
              <h2 style={{ color: '#0b5394', margin: '0 0 10px' }}>{item.name}</h2>
              <p><strong>Description:</strong> {item.description || 'No description available.'}</p>
              <p><strong>How to Get:</strong> {item.howToGet || 'Information not available. Check in-game events or shop.'}</p>
              <p><strong>Category:</strong> {item.category || 'Uncategorized'}</p>
              {item.artUrl && (
                <img src={item.artUrl} alt={item.name} style={{ maxWidth: '200px', marginTop: '10px', borderRadius: '5px' }} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Wiki;